import React from "react";
import { useTheme } from "styled-components/native";
import { LoadMoreButtonProp } from "./types";
import {
  getHeaderStyleBasedOnProduct,
  getProductThemeFromType,
} from "@components/common/Header/utils";
import { DefaultTheme } from "styled-components/native";
import { Button } from "..";
import { ButtonCategory, ButtonType } from "../Button/types";
import styled from "styled-components/native";

const LoadMoreButton = ({
  productType,
  onPress,
  text,
  isLoading,
}: LoadMoreButtonProp) => {
  const theme = useTheme();
  const { background } = getHeaderStyleBasedOnProduct(productType);

  return (
    <ButtonContainer>
      <Button
        category={getProductThemeFromType(productType) as ButtonCategory}
        type={ButtonType.tertiary}
        title={text}
        showIcon
        iconSource={"arrow-down"}
        iconColor={theme[background as keyof DefaultTheme] as string}
        iconSize={24}
        textTypographyStyle={"H3-M"}
        onPress={onPress}
        loading={isLoading}
      />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.View`
  padding-left: 8px;
  padding-right: 8px;
`;

export default LoadMoreButton;
